// extracted by mini-css-extract-plugin
module.exports = {"tabsContainer":"AvisosListado__tabsContainer__3DrbM","hidden":"AvisosListado__hidden__2hiJW","myCol":"AvisosListado__myCol__26Frn"};